import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { SystemEntityType } from "../../../system/systemEdit/SystemEdit.types.ts";
import { entityTypeOptions } from "../../../system/systemEnumOptions.ts";

export interface SystemEntityTypeFieldProps {
    entityType: SystemEntityType | undefined;
    onChange: (entityType: SystemEntityType | null) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemEntityTypeField(props: SystemEntityTypeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={entityTypeOptions(translateString)}
            selectedItem={props.entityType === undefined || props.entityType === null ? null : props.entityType.toString()}
            onChange={
                props.readOnly
                    ? () => {}
                    : (type) => {
                          props.onChange(type ? (Number(type) as SystemEntityType) : null);
                      }
            }
            placeholder={translateString("entityType")}
            label={translateString("entityType")}
            noOptionsLabel={translateString("noOptions")}
            toolTipText={translateString("entityTypeToolTip")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default SystemEntityTypeField;
